import {Row, Col} from "react-bootstrap";
function OrgUserToggle({ display, toggle }) {
  return (
    <Row className="share-controls__subuser">
      <Col>
        <a href="#" onClick={() => toggle(!display)}>
          Need to add a Sub-User?
        </a>
      </Col>
    </Row>
  );
}

export default OrgUserToggle;
